var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var RibbonButton = /** @class */ (function (_super) {
    __extends(RibbonButton, _super);
    function RibbonButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RibbonButton.prototype.render = function () {
        var cls = "rj-ribbon__button" + (this.props.modifier ? " rj-ribbon__button--" + this.props.modifier : "");
        return (React.createElement("button", { className: cls, onClick: this.props.handler }, this.props.text));
    };
    return RibbonButton;
}(React.Component));
export { RibbonButton };
//# sourceMappingURL=RibbonButton.js.map